module.exports = __webpack_public_path__ + "img/17.1138ed73.png";